import MojitoCore from 'mojito/core';

const log = MojitoCore.logger.get('QuickStartGuideServiceFactory');

const voidResponder = () => {
    log.warn('quickStartGuideService instance is missing.');
    return Promise.reject();
};

const NULL_SERVICE = {
    fetchQuickStartGuides: voidResponder,
};

/**
 * Singleton object that receives quick start guide config and spawn service instance.
 *
 * @class ServiceFactory
 * @name serviceFactory
 * @memberof Mojito.Services.QuickStartGuide
 */
class ServiceFactory {
    constructor() {
        this.service = NULL_SERVICE;
    }

    /**
     * Init factory.
     *
     * @function init
     *
     * @param {Mojito.Services.QuickStartGuide.types.QuickStartGuideConfig} config - Quick start guide config.
     *
     * @memberof Mojito.Services.QuickStartGuide.serviceFactory
     */
    init({ service }) {
        this.service = service;
    }

    /**
     * Service getter.
     *
     * @function getService
     *
     * @returns {Mojito.Services.QuickStartGuide.AbstractQuickStartGuideService} QuickStartGuide service instance.
     *
     * @memberof Mojito.Services.QuickStartGuide.serviceFactory
     */
    getService() {
        return this.service;
    }
}

export default new ServiceFactory();
